module.exports = __webpack_public_path__ + "static/media/whatsapp.803273ea.png";